import { render } from "./GroupPopoverButton.vue?vue&type=template&id=eacf6d9a"
import script from "./GroupPopoverButton.vue?vue&type=script&lang=js"
export * from "./GroupPopoverButton.vue?vue&type=script&lang=js"
script.render = render

export default script